import {
	Navigate,
	Routes as ReactRouterRoutes,
	Route,
	useLocation,
} from "react-router-dom";
import ChecklistPage from "@/pages/checklist/page";
import CopilotPage from "@/pages/copilot/page";
// Private routes
import DriversPage from "@/pages/drivers/page";
import ExpensesHistoryPage from "@/pages/expenses/history/page";
import ExpensesPage from "@/pages/expenses/page";
import ExpensesReportsPage from "@/pages/expenses/reports/page";
import FormsListPage from "@/pages/forms/list/page";
import FormsNewPage from "@/pages/forms/new/page";
import HomePrivatePage from "@/pages/home/page";
import InfractionsPage from "@/pages/infractions/page";
import InspectionsPage from "@/pages/inspections/page";
// Public routes
import LoginPage from "@/pages/login/page";
import NotFoundPage from "@/pages/not-found";
import HomePage from "@/pages/page";
import PublicLayout from "@/pages/public-layout";
import QuestionsListPage from "@/pages/questions/list/page";
import QuestionsNewPage from "@/pages/questions/new/page";
import TrackingCommunicationPage from "@/pages/tracking/communication/page";
import TrackingEventsPage from "@/pages/tracking/events/page";
import TrackingPage from "@/pages/tracking/page";
import TrackingRankingPage from "@/pages/tracking/ranking/page";
import UsersPage from "@/pages/users/page";
import VehiclesPage from "@/pages/vehicles/page";
import PrivateRoute from "@/routes/PrivateRoute";

function CopilotRootRedirect() {
	const { search } = useLocation();
	return <Navigate replace to={`/copilot/summary${search}`} />;
}

export function Routes() {
	return (
		<ReactRouterRoutes>
			{/* Public routes */}
			<Route element={<PublicLayout />}>
				<Route element={<LoginPage />} path="/login" />
			</Route>

			<Route element={<ChecklistPage />} path="/checklist" />

			{/* Private routes (com sidebar) */}
			<Route element={<PrivateRoute />}>
				<Route element={<HomePrivatePage />} path="/home" />
				<Route element={<InspectionsPage />} path="/inspections" />
				<Route element={<ExpensesPage />} path="/expenses" />
				<Route element={<ExpensesReportsPage />} path="/expenses/reports" />
				<Route element={<ExpensesHistoryPage />} path="/expenses/history" />
				<Route element={<InfractionsPage />} path="/infractions" />
				<Route element={<VehiclesPage />} path="/vehicles" />
				<Route element={<FormsListPage />} path="/forms/list" />
				<Route element={<FormsNewPage />} path="/forms/new" />
				<Route element={<QuestionsListPage />} path="/questions/list" />
				<Route element={<QuestionsNewPage />} path="/questions/new" />
				<Route element={<UsersPage />} path="/users" />
				<Route element={<DriversPage />} path="/drivers" />
				<Route element={<CopilotRootRedirect />} path="/copilot" />
				<Route element={<CopilotPage />} path="/copilot/summary" />
				<Route element={<TrackingRankingPage />} path="/tracking/ranking" />
				<Route element={<TrackingEventsPage />} path="/tracking/events" />
				<Route
					element={<TrackingCommunicationPage />}
					path="/tracking/communication"
				/>
				<Route element={<TrackingPage />} path="/tracking" />
			</Route>

			{/* Root redirect */}
			<Route element={<HomePage />} path="/" />

			{/* 404 */}
			<Route element={<NotFoundPage />} path="*" />
		</ReactRouterRoutes>
	);
}
